import {Period} from '../../common/model/period.model';
import {EntitaOrganizzativa} from '../entitaorganizzativa/entitaorganizzativa.model';
import {TableRow} from '../../common/model/table-row.model';
import {TableRowValue} from '../../common/model/table-row-value.model';
import {Helpers} from '../../common/helpers/helpers';
import { Fascia } from '../../+configurazione/fascia/fascia.model';

export class FasciaEntitaOrganizzativa extends Period {

  constructor(protected id: number,
                public fascia: Fascia,
                public entitaOrganizzativa: EntitaOrganizzativa,
                public inizioValidita,
                public fineValidita
  ) {
    super(id, inizioValidita, fineValidita);
  }

  public static getTableKeys() {
    return ['fascia', 'entitaOrganizzativa', 'Inizio', 'Fine'];
  }

  public toTableRow(): TableRow {
    const rowValues = new Map();
    rowValues.set('fascia', new TableRowValue(this.fascia.getLabel(), null));
    rowValues.set('entitaOrganizzativa', new TableRowValue(this.entitaOrganizzativa.getLabel(), null));
    rowValues.set('Inizio', new TableRowValue(Helpers.formatDateView(this.getInizio()), null));
    rowValues.set('Fine', new TableRowValue(Helpers.formatDateView(this.getFine()), null));
    return new TableRow(this, rowValues);
  }

  public getLabel() {
    return 'Assegnazione Fascia' + this.fascia.getLabel()
      + ' - ' + this.entitaOrganizzativa.getLabel();
  }

}